<mat-card>{{'productCardsInventory' | translate}}</mat-card>


<div class="container" style="padding: 25px;">

    <mat-grid-list cols="6" rowHeight="50px">

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'category' | translate}}</mat-label>
                <mat-select [(value)]="selectedCategory" (selectionChange)="onCategoryChange()">
                    <mat-option *ngFor="let item of category" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'subCategory' | translate}}</mat-label>
                <mat-select [(value)]="selectedSubCategory" (selectionChange)="onsubCategoryChange()">
                    <mat-option *ngFor="let item of subCategories" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'product' | translate}}</mat-label>
                <mat-select [(value)]="selectedProduct">
                    <mat-option *ngFor="let item of products" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

    </mat-grid-list>

    <mat-grid-list cols="6" rowHeight="50px">

        <mat-grid-tile colspan="4">
            <mat-form-field appearance="standard" class="example-form-field">
                <mat-label>{{'enterDateRange' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" #fromDate>
                    <input matEndDate placeholder="End date" #toDate>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                        <button mat-raised-button color="primary" matDateRangePickerApply>{{'done' |
                            translate}}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <button mat-raised-button color="primary" (click)="search()">
                <mat-icon>search</mat-icon>
                {{'filter' | translate}}
            </button>
        </mat-grid-tile>


    </mat-grid-list>

    <div class="mat-elevation-z8">
        <br />

        <mat-grid-list cols="6" rowHeight="50px">

            <mat-grid-tile colspan="3">
                <mat-form-field appearance="standard">
                    <mat-label>عدد البطاقات المدخلة</mat-label>
                    <input matInput readonly [(ngModel)]="productCardInventory.noOfCardsEntry">
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile colspan="3">
                <mat-form-field appearance="standard">
                    <mat-label> مجموع الكلفة للبطاقات المدخلة</mat-label>
                    <input matInput readonly [(ngModel)]="productCardInventory.totalCostOfCardsEntry">
                </mat-form-field>
            </mat-grid-tile>

        </mat-grid-list>

        <mat-grid-list cols="6" rowHeight="50px">

            <mat-grid-tile colspan="3">
                <mat-form-field appearance="standard">
                    <mat-label>عدد البطاقات المباعة</mat-label>
                    <input matInput readonly [(ngModel)]="productCardInventory.noOfCardsSold">
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile colspan="3">
                <mat-form-field appearance="standard">
                    <mat-label> مجموع الكلفة للبطاقات المباعة</mat-label>
                    <input matInput readonly [(ngModel)]="productCardInventory.totalCostOfCardsSold">
                </mat-form-field>
            </mat-grid-tile>

        </mat-grid-list>

        <mat-grid-list cols="6" rowHeight="50px">

            <mat-grid-tile colspan="3">
                <mat-form-field appearance="standard">
                    <mat-label>عدد البطاقات المتاحة بالمخزن</mat-label>
                    <input matInput readonly [(ngModel)]="productCardInventory.noOfCardsInStock">
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile colspan="3">
                <mat-form-field appearance="standard">
                    <mat-label> مجموع الكلفة للبطاقات المتاحة</mat-label>
                    <input matInput readonly [(ngModel)]="productCardInventory.totalCostOfCardsInStock">
                </mat-form-field>
            </mat-grid-tile>

        </mat-grid-list>

        <br />

    </div>

</div>


<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>